import { useState } from "react";
import { Button, Modal, Form, Input, message, Tooltip, Alert } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { getLineasActaPO, completarDatosActaPO } from "../../../../services/financiero/ingresosPO/entregasPOService";
import { descargarActaPDF } from "../pdf/descargarActaPDF";

const tiene = (v) => !!String(v ?? "").trim();

export default function DescargarActaButton({ record, userLogin, onDatosGuardados }) {

  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [generando, setGenerando] = useState(false);

  const faltaVereda = !tiene(record.vereda);

  const generar = async (extras = {}) => {
    const lineas = await getLineasActaPO({
      oid_participante: record.oid_participante,
      tipo_entrega: record.tipo_entrega,
      fecha_entrega: record.fecha_entrega
    });
    if (!lineas.length) {
      message.warning("El acta no tiene productos");
      return false;
    }
    await descargarActaPDF(record, lineas, extras);
    message.success("PDF generado");
    return true;
  };

  // Si el acta ya tiene vereda se descarga de una vez; solo se pide (una única
  // vez, porque queda guardada) cuando falta.
  const handleClick = async () => {
    if (faltaVereda) {
      form.setFieldsValue({ vereda: "" });
      setOpen(true);
      return;
    }
    try {
      setGenerando(true);
      await generar();
    } catch (error) {
      console.error(error);
      message.error("Error generando el PDF");
    } finally {
      setGenerando(false);
    }
  };

  const handleGuardarYGenerar = async () => {
    let valores;
    try {
      valores = await form.validateFields();
    } catch {
      return;
    }
    try {
      setGenerando(true);
      const extras = { vereda: valores.vereda };
      try {
        await completarDatosActaPO({
          oid_participante: record.oid_participante,
          tipo_entrega: record.tipo_entrega,
          fecha_entrega: record.fecha_entrega,
          vereda: extras.vereda
        }, userLogin);
        onDatosGuardados?.();
      } catch (error) {
        console.error(error);
        message.warning("No se pudo guardar la vereda en el acta; se usará solo para este PDF.");
      }
      if (await generar(extras)) setOpen(false);
    } catch (error) {
      console.error(error);
      message.error("Error generando el PDF");
    } finally {
      setGenerando(false);
    }
  };

  return (
    <>
      <Tooltip title="Descargar acta en PDF">
        <Button
          size="small"
          icon={<FilePdfOutlined />}
          loading={generando && !open}
          onClick={handleClick}
        />
      </Tooltip>
      <Modal
        open={open}
        title="Completar datos del acta"
        onCancel={() => setOpen(false)}
        onOk={handleGuardarYGenerar}
        okText="Guardar y descargar PDF"
        cancelText="Cancelar"
        confirmLoading={generando}
        destroyOnClose
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
          message={`A esta acta de ${record.nombre_entrega} le falta la vereda.`}
          description="Queda guardada en el acta y no se volverá a pedir."
        />
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item
            name="vereda"
            label="Vereda"
            rules={[{ required: true, whitespace: true, message: "Ingrese la vereda" }]}
          >
            <Input maxLength={150} placeholder="Ej: San Clemente" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
